import ShelfButton from './ShelfButton';
import { TShelves } from 'utils/types';

type StorefrontMapProps = {
  shelvesByCode: Record<string, TShelves>;
  selectedCode?: string | null;
  onSelectShelf: (code: string, shelf?: TShelves) => void;
};

const StorefrontMap = ({
  shelvesByCode,
  selectedCode,
  onSelectShelf
}: StorefrontMapProps) => {
  const common = {
    shelvesByCode,
    selectedCode,
    onSelect: onSelectShelf
  };

  return (
    <div className="warehouse-floor-map storefront-map">
      <ShelfButton code="S7" className="storefront-s7-back" {...common} />
      <ShelfButton code="S7" className="storefront-s7-right" {...common} />
      <ShelfButton code="S7" className="storefront-s7-hook" {...common} />
      <ShelfButton code="S8" className="storefront-s8" {...common} />
      <ShelfButton code="S5" className="storefront-s5-run" {...common} />
      <ShelfButton code="S5" className="storefront-s5-side" {...common} />
      <ShelfButton code="S6-A" className="storefront-s6a" {...common} />
      <ShelfButton code="S6-B" className="storefront-s6b" {...common} />
      <div className="storefront-gondola storefront-s4">
        <ShelfButton code="S4-B" {...common} />
        <ShelfButton code="S4-A" {...common} />
      </div>
      <div className="storefront-gondola storefront-s3">
        <ShelfButton code="S3-B" {...common} />
        <ShelfButton code="S3-A" {...common} />
      </div>
      <div className="storefront-gondola storefront-s2">
        <ShelfButton code="S2-B" {...common} />
        <ShelfButton code="S2-A" {...common} />
      </div>
      <ShelfButton code="S1" className="storefront-s1" {...common} />
      <div className="warehouse-floor-hint storefront-front-label">FRONT</div>
    </div>
  );
};

export default StorefrontMap;
